import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Course } from "@/lib/types";
import { StripePrice } from '@/types';
import { EnrollmentButton } from "./EnrollmentButton";

interface CourseHeaderProps {
  course: Course & { default_price?: StripePrice | null };
  isPurchased: boolean;
  lang: string;
  hasAccess?: boolean;
  setHasAccess?: (value: boolean) => void;
  userId?: string;
  setAuthModalOpen?: (isOpen: boolean) => void;
  showEnrollmentButton?: boolean; // NEW: control button visibility
}

export function CourseHeader({ 
  course, 
  isPurchased, 
  lang, 
  hasAccess, 
  setHasAccess, 
  userId, 
  setAuthModalOpen,
  showEnrollmentButton = true // NEW: default to true
}: CourseHeaderProps) {
  return (
    <div className="mb-8">
      <Link
        to="/courses"
        className="inline-flex items-center mb-8 text-primary hover:underline"
      >
        <ArrowLeft className="mr-2 h-4 w-4" /> Back to Courses
      </Link>
      
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-6">
          <div className="flex-1">
            <h1 className="text-4xl font-bold leading-tight">{course.title}</h1>
            <p className="text-xl text-muted-foreground leading-relaxed mt-4">{course.description}</p>
          </div>
          
          {/* Enrollment button */}
          <div className="flex-shrink-0">
            {showEnrollmentButton && setHasAccess && setAuthModalOpen && (
              <EnrollmentButton
                course={course}
                userId={userId}
                hasAccess={hasAccess || false}
                setHasAccess={setHasAccess}
                lang={lang}
                setAuthModalOpen={setAuthModalOpen}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
